import { useContracts } from './contracts.hook'

export function useCurrentContract() {
  return useContracts({
    select: (contracts) =>
      contracts.find((contract) => contract.isCurrent) ??
      contracts.filter((contract) => contract.isForOrder)?.[0],
  })
}
